import PageLayout from "../components/pageLayout";
import UserProfileDetail from "../components/UserProfileDetail";

export default function UserProfileDetailPage() {
    return (
        <PageLayout children={<UserProfileDetail />} />
    )
}
